import * as React from 'react';
import {Node} from "../../../../model/Graph";
import {WizardContext} from "../../../../service/cody-wizard/context/wizard-context";
import {withNamespaces, WithNamespaces} from "react-i18next";
import {Checkbox, FormField} from "semantic-ui-react";

interface OwnProps {
  vo: Node | null;
  isQueryable: boolean;
  onQueryableChanged: (isQuyable: boolean) => void;
  ctx: WizardContext;
  disabled?: boolean;
}

type QueryableToggleProps = OwnProps & WithNamespaces;

const QueryableToggle = (props: QueryableToggleProps) => {
  const disabled = props.disabled || !props.vo;

  return <FormField disabled={disabled} inline={true}>
    <Checkbox value={1}
              checked={props.isQueryable}
              disabled={disabled}
              toggle={true}
              onChange={() => props.onQueryableChanged(!props.isQueryable)}
              label={props.t('insp.cody_wizard.step_any_vo.is_queryable_label') as string} />
  </FormField>
};

export default withNamespaces()(QueryableToggle);
